import { connectedAccountsStore } from '../../store/store';
import { mutatorAction } from 'satcheljs';
export var updateEditDisplayName = mutatorAction('updateEditDisplayName', function (displayName) {
    var store = connectedAccountsStore();
    store.editAccountState.displayName = displayName;
});
//# sourceMappingURL=updateEditDisplayName.js.map